// import { AutocompleteSearch } from '@cloudsuite/theme_library/scripts/global/autocomplete-search';
import { AutocompleteSearch } from './global/autocomplete-search';

document.addEventListener("DOMContentLoaded", function () {
    AutocompleteSearch.init();

    // Add help to search when finished loading searched
    function SearchHelper() {
        // Html blocks
        const helpBlock = document.querySelector('[data-js="need-help-block"]');
        const languageCode = helpBlock.dataset.languageCode;
        const noSearchBlock = document.querySelector('[data-js-no-search-block]');
        const child = document.createElement('div');
        child.className = "search-item__title";
        child.textContent = js_translations['searchItem'];

        // All product
        const product = document.createElement('a')
        product.className = "search-item__link";
        product.textContent = js_translations['allProducts'];

        // Selectors
        const searchModal = document.getElementById('searchModal');
        const searchField = searchModal.getElementsByClassName('form-control')[0];
        const searchResult = searchModal.getElementsByClassName('autocomplete-search__results')[0];
        const searchForm = searchModal.querySelector('.autocomplete-search');


        // Buttons
        const openSearchBtn = document.querySelectorAll('[data-js="openSearchModal"]');
        const closeBtn = searchModal.getElementsByClassName('sidebar-close')[0];
        const searchBtn = searchForm.querySelector('.btn .fa-search');
        const searchBtnDiv = document.createElement('p');
        searchBtnDiv.textContent = js_translations['searchButtonText'];

        if (searchField) {
            const helpBlockLinks = helpBlock.querySelectorAll('li a');
            helpBlockLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "send",
                        eventCategory: "Search",
                        eventAction: `Results: ${languageCode}`,
                        eventLabel: `${encodeURIComponent(searchField.value).replaceAll('%20', '+').toLowerCase()}`,
                    });
                });
            });

            searchResult.append(helpBlock);
            searchResult.append(noSearchBlock);
            let searchLength = 0;


            searchField.addEventListener('keyup', () => {
                searchLength = searchField.value.length;

                product.setAttribute("href", "/search/?search_term=" + searchField.value);
                if (searchLength >= 1) {
                    searchBtn.append(searchBtnDiv);
                    searchBtn.classList.add('active');
                }
                else {
                    searchBtn.removeChild(searchBtnDiv);
                    searchBtn.classList.remove('active');
                }

                if (searchLength >= 3) {
                    searchModal.classList.remove('has-no-results');

                    var config = { attributes: false, childList: true, characterData: false };
                    var target = searchModal.querySelector('.autocomplete-search__results');
                    var observer = new MutationObserver(function (mutations) {
                        mutations.forEach(function (mutation) {
                            if (target.querySelector('.ac_search')) {
                                target.querySelector('.ac_search').prepend(child);
                            }

                            if (target.querySelector('.ac_popular')) {
                                target.querySelector('.ac_popular').querySelector('.search-item__title').prepend(product);
                            }

                            if (target.querySelectorAll('.search-item').length == 1) {
                                target.classList.add('_nosearch-found')
                                noSearchBlock.querySelector('[data-js-no-search-result]').innerHTML = target.querySelector('.ac_search .search-item__content-item').innerHTML;
                            } else {
                                target.classList.remove('_nosearch-found');
                            }
                        });
                    });

                    observer.observe(target, config);

                } else {
                    searchModal.classList.add('has-no-results');
                }
            });

            // Focus directly when model open
            openSearchBtn.forEach(button => {
                button.addEventListener('click', () => {
                    $('#searchModal').on('shown.bs.modal', function (e) {
                        searchField.focus();
                    });

                });
            });


            // Empty search when modal close
            $('#searchModal').on('hidden.bs.modal', function () {
                searchModal.classList.add('has-no-results');
                searchField.value = "";
                searchLength = 0;
                $("body").removeClass("search-open");

            });

            $('#searchModal').on('show.bs.modal', function () {
                $("body").addClass("search-open");
            });

            product.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "send",
                    eventCategory: "Search",
                    eventAction: `Results: ${languageCode}`,
                    eventLabel: `${encodeURIComponent(searchField.value).replaceAll('%20', '+').toLowerCase()}`,
                });
            });
        }
    }
    SearchHelper()
});